import React, { useState } from 'react';

import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';
import EventCalendar from 'pages/private/owner/Scheduling/components/EventCalendar';

import ScheduleHeader from './components/ScheduleHeader';
import { FilterTerms } from './types';

const Schedule = (): JSX.Element => {
  const initialSearchFiltersValue = {
    eventTypes: [],
    coaches: [],
    locations: [],
  };
  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);
  const [isCreateClassFormOpen, createClassFormHandlers] = useDisclosure(false);
  const [isCreateAppointmentFormOpen, createAppointmentFormHandlers] = useDisclosure(false);

  const { hasPerm } = useAuth();
  const schedulingPerm = hasPerm('EventMutate');

  return (
    <>
      <ScheduleHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        handleOpenCreateClassForm={createClassFormHandlers.open}
        handleOpenCreateAppointmentForm={createAppointmentFormHandlers.open}
        setSearchFilters={setSearchFilters}
        searchFilters={searchFilters}
        permission={schedulingPerm}
      />
      <EventCalendar
        isCreateAppointmentFormOpen={isCreateAppointmentFormOpen}
        createAppointmentFormHandlers={createAppointmentFormHandlers}
        isCreateClassFormOpen={isCreateClassFormOpen}
        createClassFormHandlers={createClassFormHandlers}
        searchFilters={{
          ...debouncedSearchFilters,
          locations: debouncedSearchFilters.locations.map(location => {
            return location.replace('noLocation', 'None');
          }),
          coaches: debouncedSearchFilters.coaches.map(coach => {
            return coach.replace('noStaff', 'None');
          }),
        }}
        permission={schedulingPerm}
        isDesktop={false}
      />
    </>
  );
};

export default Schedule;
